import React, { useEffect, useState } from "react";
import { Link, useNavigate, useNavigation } from "react-router-dom";
import { getIndustryList } from "../../service/ai.service";
import { clearStorage, getStorageData, setStorageData } from "../../service/storage.service";
import { Constant, SECTION_NAMES } from "../../helper/constant";
import useAlert from "../../component/alerts/user.alert";
import { useAppContext } from "../../context/app.context";


const ATTRITION_RATE = [10, 15, 20, 25];
const MACHINE_DOWNTIME = [10, 15, 20, 25];

const CompanyIntro = () => {
    const [userInfo, setUserInfo] = useState({ inventory_currency: 'USD', revenue_currency: 'USD' });
    const [industries, setIndustries] = useState([]);
    const [competitorList, setCompetitorList] = useState([{}]);
    const [supplierList, setSupplierList] = useState([{}]);
    const [customerList, setCustomerList] = useState([{}]);
    const navigate = useNavigate()
    const { updateCompnayInfoSaveStatus } = useAppContext();
    const { show } = useAlert();

    useEffect(() => {
        getIndustryList()
            .then(res => {
                if (res && res.length > 0) {
                    setIndustries(res);
                }
            }).catch(e => e);
        getUserInfo();
        return () => { }
    }, []);

    const getUserInfo = () => {
        const data = getStorageData(Constant.STORAGE_KEYS.USER_INFO);
        if (data) {
            setUserInfo(data.userInfo || {});
            setCompetitorList(data.competitorList || [{}]);
            setSupplierList(data.supplierList || [{}]);
            setCustomerList(data.customerList || [{}]);
        }
    }

    const clearUserInfo = () => {
        setUserInfo({});
        setCompetitorList([{}]);
        setSupplierList([{}]);
        setCustomerList([{}]);
        clearStorage(Constant.STORAGE_KEYS.USER_INFO);
        show("User information cleared", { type: "success", timeout: 4000 });
        updateCompnayInfoSaveStatus(false);
    }

    const handleFormChange = (key, value) => {
        const fields = { ...userInfo };
        fields[key] = value;
        setUserInfo(fields);
    };


    const onFormSubmit = (e) => {
        e.preventDefault();
        const { org_name, org_url, industry, revenue, employee_count } = userInfo;
        if (org_name && org_url && industry && revenue && employee_count) {
            show("User information saved", { type: "success", timeout: 4000 });
            setStorageData(Constant.STORAGE_KEYS.USER_INFO, { userInfo, supplierList, competitorList, customerList });
            updateCompnayInfoSaveStatus(true);
            navigate('/ai-maturity-eval');
        } else {
            show("Mandatory fields empty", { type: "danger", timeout: 4000 });
        }
    }

    const renderCompanyName = () => {
        return (
            <div className="row align-items-center">
                <div className="col-md-2">
                    <div className="font-weight-bold">Company Name<span className="text-danger"> *</span></div>
                </div>
                <div className="col-md-6">
                    <input
                        type="text"
                        className="form-control"
                        value={userInfo?.org_name || ''}
                        onChange={(e) => handleFormChange("org_name", e.target.value)}
                    />
                </div>
            </div>
        )
    }

    const renderCompetitorList = () => {
        return <ExternalCompany
            type={'Competitor'}
            list={competitorList}
            setList={setCompetitorList} />
    }


    const renderSupplierList = () => {
        return <ExternalCompany
            type={'Supplier'}
            list={supplierList}
            setList={setSupplierList} />
    }



    const renderCustomerList = () => {
        return <ExternalCompany
            type={'Customer'}
            list={customerList}
            setList={setCustomerList} />
    }

    const renderCompanyWebsite = () => {
        return (
            <div className="row align-items-center">
                <div className="col-md-2">
                    <div className="">Company Website<span className="text-danger"> *</span></div>
                </div>
                <div className="col-md-6">
                    <input
                        type="text"
                        className="form-control"
                        value={userInfo?.org_url || ''}
                        onChange={(e) => handleFormChange("org_url", e.target.value)}
                    />
                </div>
            </div>
        )
    }

    const renderIndustry = () => {
        return (
            <div className="row align-items-center">
                <div className="col-md-2">
                    <div className="">Industry<span className="text-danger"> *</span></div>
                </div>
                <div className="col-md-3">
                    <select className="form-control capitalize"
                        value={userInfo?.industry || ''} onChange={e => handleFormChange('industry', e.target.value)}>
                        <option selected value="0">Select</option>
                        {(industries.length > 0) && industries.map((item, index) => <option key={index} value={item.id}>{item.industry_name}</option>)}
                    </select>
                </div>
            </div>
        )
    }

    const renderCompanyAddress = () => {
        return (
            <div className="row align-items-center">
                <div className="col-md-2">
                    <div className="">Company Address<span className="text-danger"> *</span></div>
                </div>
                <div className="col-md-6">
                    <textarea
                        className="form-control"
                        rows="2"
                        id="comment"
                        name="text"
                        value={userInfo?.org_address || ''}
                        onChange={(e) => handleFormChange("org_address", e.target.value)}
                    ></textarea>
                </div>
            </div>
        )
    }

    const renderInventroy = () => {
        return (
            <div className="row align-items-center">
                <div className="col-md-6">
                    <div className="row align-items-center">
                        <div className="col-md-4">Inventory (in Millions)</div>
                        <div className="col-md-3">
                            <div className="d-flex justify-content-centent align-items-center gap-2">
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="radio1" name="inventory_currency" value="USD" checked={userInfo.inventory_currency === 'USD'} onChange={(e) => handleFormChange('inventory_currency', e.target.value)} />
                                    <label htmlFor="radio1">$</label>
                                </div>
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="radio2" name="inventory_currency" value="GBP" checked={userInfo.inventory_currency === 'GBP'} onChange={(e) => handleFormChange('inventory_currency', e.target.value)} />
                                    <label htmlFor="radio2">£</label>
                                </div>
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="radio3" name="inventory_currency" value="EUR" checked={userInfo.inventory_currency === 'EUR'} onChange={(e) => handleFormChange('inventory_currency', e.target.value)} />
                                    <label htmlFor="radio3">€</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <input
                                type="text"
                                className="form-control"
                                value={userInfo?.inventory || ''}
                                onChange={(e) => handleFormChange("inventory", e.target.value)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const renderRevenue = () => {
        return (
            <div className="row align-items-center">
                <div className="col-md-6">
                    <div className="row align-items-center">
                        <div className="col-md-4">Revenue (in Millions)<span className="text-danger"> *</span></div>
                        <div className="col-md-3">
                            <div className="d-flex justify-content-centent align-items-center gap-2">
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="radio4" name="revenue_currency" value="USD" checked={userInfo.revenue_currency === 'USD'} onChange={(e) => handleFormChange('revenue_currency', e.target.value)} />
                                    <label htmlFor="radio4">$</label>
                                </div>
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="radio5" name="revenue_currency" value="GBP" checked={userInfo.revenue_currency === 'GBP'} onChange={(e) => handleFormChange('revenue_currency', e.target.value)} />
                                    <label htmlFor="radio5">£</label>
                                </div>
                                <div className="form-check">
                                    <input type="radio" className="form-check-input" id="radio6" name="revenue_currency" value="EUR" checked={userInfo.revenue_currency === 'EUR'} onChange={(e) => handleFormChange('revenue_currency', e.target.value)} />
                                    <label htmlFor="radio6">€</label>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <input
                                type="text"
                                className="form-control"
                                value={userInfo?.revenue || ''}
                                onChange={(e) => handleFormChange("revenue", e.target.value)}
                            />
                        </div>
                    </div>
                </div>

            </div>
        )
    }

    const renderEmployeeCount = () => {
        return (
            <div className="row align-items-center">
                <div className="col-md-2">
                    <div className="">Employee Count<span className="text-danger"> *</span></div>
                </div>
                <div className="col-md-3">
                    <input
                        type="text"
                        className="form-control"
                        value={userInfo?.employee_count || ''}
                        onChange={(e) => handleFormChange("employee_count", e.target.value)}
                    />
                </div>
            </div>
        )
    }

    const renderAttritionRate = () => {
        return (
            <div className="row align-items-center">
                <div className="col-md-2">
                    <div className="">Customer Attrition Rate</div>
                </div>
                <div className="col-md-3">
                    <select className="form-control"
                        value={userInfo?.attrition_rate || ''} onChange={e => handleFormChange('attrition_rate', e.target.value)}>
                        <option selected value="0">Select</option>
                        {ATTRITION_RATE.map(((item, i) => <option key={i} value={item} >{item}%</option>))}
                    </select>
                </div>
            </div>
        )
    }

    const renderMachineDown = () => {
        return (
            <div className="row align-items-center">
                <div className="col-md-2">
                    <div className="">Unplanned Machine downtime</div>
                </div>
                <div className="col-md-3">
                    <select className="form-control"
                        value={userInfo?.machine_downtime || ''} onChange={e => handleFormChange('machine_downtime', e.target.value)}>
                        <option selected value="0">Select</option>
                        {MACHINE_DOWNTIME.map(((item, i) => <option key={i} value={item} >{item}%</option>))}
                    </select>
                </div>
            </div>
        )
    }

    return (
        <>
            <h3 className=" text-blue h4 mb-5 mb-0">{SECTION_NAMES.COMAPANY_INFO}</h3>
            <form onSubmit={onFormSubmit} className="company-info-form" onReset={clearUserInfo}>
                {renderCompanyName()}
                {renderCompanyWebsite()}
                {renderIndustry()}
                {/* {renderCompanyAddress()} */}
                {renderRevenue()}
                {renderInventroy()}
                {renderEmployeeCount()}
                {renderAttritionRate()}
                {renderMachineDown()}
                <div className="border-top py-2 d-flex gap-2 flex-column">
                    {renderCompetitorList()}
                </div>
                <div className="border-top py-2 d-flex gap-2 flex-column">
                    {renderSupplierList()}
                </div>
                <div className="border-top py-2 d-flex gap-2 flex-column">
                    {renderCustomerList()}
                </div>
                <div className="d-flex mx-auto gap-3 mt-3 w-50">
                    <button type="reset" className="btn1 font-weight-bold mx-auto danger w-50" >CLEAR</button>
                    <button type="submit" className="btn1 font-weight-bold mx-auto w-50" >SUBMIT</button>
                </div>
            </form>
        </>
    );
};

export default CompanyIntro;


const ExternalCompany = ({ type, list, setList, data }) => {


    const onItemDelete = index => {
        if (index === 0) {
            setList([{}]);
            return
        }
        const data = list.slice();
        data.splice(index, 1);
        setList(data);
    }

    const onAddItem = () => {
        const data = list.slice();
        data.push({})
        setList(data);
    }


    const handleFormChange = (key, value, index) => {
        const fields = list.slice();
        fields[index][key] = value;
        setList(fields);
    };
    const renderOrgNameField = (data, index) => {
        return (
            <div className="row align-items-center">
                <div className="col-md-4">
                    <div className="">Org Name</div>
                </div>
                <div className="col-md-8">
                    <input
                        type="text"
                        className="form-control"
                        value={data?.org_name}
                        onChange={(e) => handleFormChange('org_name', e.target.value, index)}
                    />
                </div>
            </div>
        )
    }

    const renderRevenueField = (data, index) => {
        return (
            <div className="row align-items-center">
                <div className="col-md-4">
                    <div className="">Revenue</div>
                </div>
                <div className="col-md-8">
                    <input
                        type="text"
                        className="form-control"
                        value={data?.revenue}
                        onChange={(e) => handleFormChange('revenue', e.target.value, index)}
                    />
                </div>
            </div>
        )
    }

    const renderEmpCountField = (data, index) => {
        return (
            <div className="row align-items-center">
                <div className="col-md-6">
                    <div className="">Employee Count</div>
                </div>
                <div className="col-md-6">
                    <input
                        type="text"
                        className="form-control"
                        value={data?.emp_count}
                        onChange={(e) => handleFormChange('emp_count', e.target.value, index)}
                    />
                </div>
            </div>
        )
    }

    const renderWebsiteField = (data, index) => {
        return (
            <div className="row align-items-center">
                <div className="col-md-4">
                    <div className="">Website</div>
                </div>
                <div className="col-md-8">
                    <input
                        type="text"
                        className="form-control"
                        value={data?.url}
                        onChange={(e) => handleFormChange('url', e.target.value, index)}
                    />
                </div>
            </div>
        )
    }

    const render = () => {
        return (<>
            <div className="font-weight-bold">{type}</div>
            {list.map((data, index) => {
                return (
                    <div className="d-flex flex-column gap-3">
                        <div className="row align-items-center" key={index}>
                            <div className="col-md-3">
                                {renderOrgNameField(data, index)}
                            </div>
                            <div className="col-md-3">
                                {renderEmpCountField(data, index)}
                            </div>
                            <div className="col-md-3">
                                {renderWebsiteField(data, index)}
                            </div>
                            <div className="col-md-2">
                                {renderRevenueField(data, index)}
                            </div>
                            <div className="col-md-1">
                                <Link style={{ fontSize: 28, color: 'red' }} onClick={() => { onItemDelete(index) }}><i className="fa fa-trash-o"></i></Link>
                            </div>
                        </div>
                    </div>
                )
            })}
            <Link onClick={() => onAddItem()}>+ Add more {type}</Link>
        </>
        )
    }
    return render();
}